import {Suspense} from "react";
import {Modal} from "react-bootstrap";

import Button from "@/components/button/Button.tsx";
import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {AlertDetails} from "@/pages/alerting/components/details/AlertDetails.tsx";
import {AlertDetailsModalButtons} from "@/pages/alerting/components/details/AlertDetailsModalButtons.tsx";

export type AlertDetailsDrawerProps = {
  id?: number;
  show: boolean;
  hide: () => void;
};

export const AlertDetailsModal = ({id, show, hide}: AlertDetailsDrawerProps) => {
  if (!id) {
    return null;
  }
  return (
    <FormModal
      show={show}
      size={"lg"}
      onCancel={hide}
      formId={"alert-details-modal"}
      hasSubmitButton={false}
      hasCancelButton={true}
      title={"Alert Details"}
      footer={
        <Modal.Footer>
          <Suspense>
            <UpErrorBoundary>
              <AlertDetailsModalButtons id={id} />
            </UpErrorBoundary>
          </Suspense>
          <Button onClick={hide}>Close</Button>
        </Modal.Footer>
      }
    >
      <Suspense>
        <AlertDetails id={id} />
      </Suspense>
    </FormModal>
  );
};
